module.exports = __webpack_public_path__ + "img/login-bg-new.a31f76cd.png";